import type { FormFields } from '@/entities/purchase-form';

import type { FulfilmentMethodSelection } from '../model';

export function formatFulfillmentMethodOrder(
    fulfilmentMethod: FormFields['fulfilmentMethod'],
    purchaseOption: FormFields['purchaseOption']
): FulfilmentMethodSelection {
    return `${fulfilmentMethod} ${purchaseOption}`;
}
